import { z } from 'zod';

/**
 * Whether a deployment shows times on a 12- or 24-hour clock — `brand.timeFormat`.
 *
 * A brand fact rather than a locale one, for the reason `WeekStartDaySchema`
 * gives: two brands serving the same language routinely disagree about it, and
 * CLDR would answer for the reader's locale rather than for the market.
 */
export const TIME_FORMATS = ['12h', '24h'] as const;

export const TimeFormatSchema = z.enum(TIME_FORMATS);

export type TimeFormat = (typeof TIME_FORMATS)[number];

/** The registry's coded default, and what a client reads until the payload lands. */
export const DEFAULT_TIME_FORMAT: TimeFormat = '24h';
